export default __webpack_public_path__ + "static/media/01_motor_Usabilidad.c2156a8b.svg";